module.exports = __webpack_public_path__ + "img/many_resume_active.12b0af24.png";